import React, { useEffect, useRef, useState } from 'react';
import { MenuForm } from '../Menu.js';
import { SecurityElement } from '../elements/security_element.js';
import { useAPICall } from '../../hooks/useAPICall.js';

import { useNavigate } from 'react-router-dom';
import DatePicker from 'react-datepicker';
import 'react-datepicker/dist/react-datepicker.css';
import { PageMenuElement } from '../elements/page_menu.js';


export function AdminYearsForm() {


    const [pageData, setPageData] = useState();
    const [yearData, setYearData] = useState([]);
    const [yearEnd, setYearEnd] = useState(new Date());
    let currentYear = useRef();
    const navigate = useNavigate();
    let first_render = useRef(true);

    const { MakeCall } = useAPICall();



    useEffect(() => {
        if (first_render.current === true) {
            LoadYearData(false);
            first_render.current = false;
        }
    });


    const handleMemberDataFetchForView = (data) => {
        setPageData(data);
        setYearData(data.components['years']);
        for (let i = 0; i < data.components['years'].length; i++) {
            let year = data.components['years'][i];
            if (new Date(year.peveril_year_end).getFullYear() === 2001) {               
                currentYear.current = year;
            }
        }

    }
    function handleNav(destination, state) {
        navigate(destination, state);
    }
    function LoadYearData(forceCall) {

        MakeCall('admin/getyearspage', "{ \"token\" : \"" + sessionStorage.getItem("Token") + "\"}", handleMemberDataFetchForView, forceCall);
    }

    function ShowYears() {
        let results = [];


        for (let i = 0; i < yearData.length; i++) {
            let year = yearData[i];
            if (new Date(year.peveril_year_end).getFullYear() === 2001) {
                results.push(<div className='formrowcentered' key={year.idpeveril_year}>
                    <div className='formlabel'>{year.peveril_year_name}</div>
                    <div className='formlabel'>
                        {new Date(year.peveril_year_start).toLocaleDateString('en-gb', { day: "numeric", year: "numeric", month: "short" })}
                    </div>
                    <div className='formlabel'>
                        CURRENT YEAR
                    </div>
                </div>)
               
            }
            else {
                results.push(<div className='formrowcentered' key={year.idpeveril_year}>
                    <div className='formlabel'>{year.peveril_year_name}</div>
                    <div className='formlabel'>
                        {new Date(year.peveril_year_start).toLocaleDateString('en-gb', { day: "numeric", year: "numeric", month: "short" })}
                    </div>
                    <div className='formlabel'>
                        {new Date(year.peveril_year_end).toLocaleDateString('en-gb', { day: "numeric", year: "numeric", month: "short" })}
                    </div>
                </div>)
            }

        }

        return results;
    }

    function handleSaveYearEnd(data)
    {
        if (data.components['result'].succeeded === true) {

            LoadYearData(true);
            document.getElementById("closeyearform").style.display ="none"
        }   
    }

    function handleCloseCurrentYear() {

        let yearName = document.getElementById('newyearname').value

        MakeCall('admin/closeyear', "{ \"token\" : \"" + sessionStorage.getItem("Token") + "\"," +
                "\"yearid\":\"" + currentYear.current.idpeveril_year + "\", "+
                "\"yearend\":\"" + yearEnd.toLocaleDateString('en-GB',  {year: 'numeric', month: 'long', day: 'numeric'}) + "\", " +
                "\"yearname\":\"" + yearName + "\"}", handleSaveYearEnd, true);
    }

    function ShowCompleteYear() {
        if (currentYear.current) {
            return (
                <div className='popup_form' id="closeyearform">
                    <h1>Close the current year</h1>
                    <p>This will set all member's statuses to pending on the year end date, and start a new year</p>
                    <div className='formrow' style={{"paddingBottom":"1em"}}>
                        <div className='formlabel' style={{ "width": "30%" }}>
                            Current Year Name
                        </div>
                        <div className='formvalue'>
                           {currentYear.current.peveril_year_name}
                        </div>
                    </div>
                    <div className='formrow'>
                        <div className='formlabel' style={{ "width": "30%" }}>
                            Current Year Start:
                        </div>
                        <div className='formvalue'>
                            {new Date(currentYear.current.peveril_year_start).toLocaleDateString('en-gb', { day: "numeric", year: "numeric", month: "short" })}
                        </div>
                    </div>
                    <div className='formrow' style={{"paddingBottom":"1em"}}>
                        <div className='formlabel' style={{ "width": "30%" }}>
                            Current Year End:
                        </div>
                        <div className='formvalue'>
                            {<DatePicker
                                showIcon
                                selected={yearEnd}
                                onChange={(date) => setYearEnd(date)}
                                name="startDate"
                                dateFormat="dd/MM/yyyy" />}

                        </div>
                    </div>
                    <div className='formrow' style={{"paddingBottom":"1em"}}>
                        <div className='formlabel' style={{ "width": "30%" }}>
                            New Year Name
                        </div>
                        <div className='formvalue'>
                           <input id='newyearname' type="text" className='logininput'/>
                        </div>
                    </div>
                    <div className='formrowcentered'>
                    
                        <div className='formlabel'>
                            <input type='button' className='prcbtn' value='Close Year' onClick={handleCloseCurrentYear}/>
                        </div>
                        <div className='formlabel'>
                            <input type='button' className='prcbtn' value='Cancel' onClick={()=>{document.getElementById("closeyearform").style.display ="none"}}/>
                        </div>
                    </div>
                </div>);
        }
    }

    function onPageMenuClick(onclickname) {
        switch (onclickname) {
            case 'goback':
                handleNav("/Admin");
                break;
            case 'closeyear':
                document.getElementById("closeyearform").style.display ="block";
                break;
            default:
                break;
        }
    }
    return (

        <div>

            {SecurityElement(pageData)}
            {MenuForm()}
            {ShowCompleteYear()}
            <div className="contentdiv">
            {PageMenuElement("Manage Years", [{ "name": "Back", "onclick": "goback" },
                { "name": "Close Current Year", "onclick": "closeyear" }], onPageMenuClick)}
               <div className='formbox'>
               <div className='formtitle'>Manage Years</div>
                This form allows you to manage the peveril membership years. Here you can close the current year and create a new year. When the old year is closed, it will set all active members to Pending status on the date of the year end.
                </div>
                <div className='formbox'>
                    <div className='formtitle'>Years</div>
                    <div className='formrowcentered' key='titles'>
                        <div className='formlabel' style={{"fontWeight" : "600"}}>Year Name</div>
                        <div className='formlabel' style={{"fontWeight" : "600"}}>Year Start</div>
                        <div className='formlabel'style={{"fontWeight" : "600"}}>Year End</div>
                    </div>
                    {ShowYears()}
                </div>

           
            </div>
        </div>


    );
}
